<template>
  <div>
    <custom-square :title="detailsObject.id.toString()">
      <template slot="squareInfo">
        <OverlayProgress :active="loading" />

        <img v-if="loaded" :src="imageURL" class="square__image" />

        <template v-else>
          <b-button
            v-if="!loading"
            class="my-4 load-button"
            @click="onLoadData()"
            >Load</b-button
          >
        </template>
        <!--img :src="detailsObject.file" alt class="square__image" /-->
        <ul class="square-list">
          <li class="square-list__item" v-if="detailsObject.filename">
            <span class="square-list__key">
              <strong>Filename</strong>
            </span>
            <p class="square-list__value">{{ detailsObject.filename }}</p>
          </li>
          <li class="square-list__item" v-if="detailsObject.patientid">
            <span class="square-list__key">
              <strong>Patient Id</strong>
            </span>
            <p class="square-list__value">{{ detailsObject.patientid }}</p>
          </li>
          <!--li class="square-list__item" v-if="detailsObject.status">
            <span class="square-list__key">
              <strong>Status</strong>
            </span>
            <p class="square-list__value">{{ detailsObject.status }}</p>
          </li>
          <li class="square-list__item">
            <span class="square-list__key">
              <strong>Study</strong>
            </span>
            <p class="square-list__value">{{ detailsObject.study }}</p>
          </li>
          <li class="square-list__item">
            <span class="square-list__key">
              <strong>Type</strong>
            </span>
            <p class="square-list__value">{{ detailsObject.datatype }}</p>
          </li-->
          <li class="square-list__item">
            <span class="square-list__key">
              <strong>Created</strong>
            </span>
            <p class="square-list__value">
              {{ convertData(detailsObject.created_at) }}
            </p>
          </li>
          <li class="square-list__item">
            <span class="square-list__key">
              <strong>Updated</strong>
            </span>
            <p class="square-list__value">
              {{ convertData(detailsObject.updated_at) }}
            </p>
          </li>
          <li class="square-list__item" v-if="blobURL">
            <span class="square-list__key">
              <strong>Options</strong>
            </span>
            <p class="square-list__value">
	      <button
                class="anno-table__btn"
                @click="downloadFile(imageURL)">
                Download
              </button>
            </p>
          </li>
          <li class="square-list__item">
	  Path:<br />
              {{ detailsObject.file }}
          </li>
        </ul>
      </template>
    </custom-square>

    <AmazonLogin ref="AmazonLogin" />
  </div>
</template>

<script>
import axios from "axios";
import parseUrl from "parse-url";
import { mapState } from "vuex";
import { apiError } from "@/util/ErrorMessage.js";
import { isGraphicFile } from "@/util/FileUtil.js";
import DICOMConverter from "@/util/DICOMConverter.js";
import OverlayProgress from "@/customReusableComponents/OverlayProgress";
import CustomSquare from "@/customReusableComponents/CustomSquare";
import AmazonLogin from "@/pages/authorization/AmazonLogin";
// Added because of new AWS error below
import AWS from "aws-sdk";

export default {
  components: {
    CustomSquare,
    OverlayProgress,
    AmazonLogin
  },
  data() {
    return {
      loading: true,
      loaded: false,
      imageURL: "",
      blobURL: "",
    };
  },
  computed: {
    ...mapState({
      s3CredentialsSet: state => state.users.s3CredentialsSet
    }),
    detailsObject() {
      return this.$store.getters.detailsObject;
    }
  },
  methods: {
    convertData(data) {
      return new Date(data)
        .toDateString()
        .split(" ")
        .slice(1, 4)
        .join(" ");
    },
    downloadFile () {
    	var a = document.createElement("a");
    	document.body.appendChild(a);
    	a.style = "display: none";
	a.href = this.blobURL;
        a.download = this.detailsObject.filename;
        a.click();
        window.URL.revokeObjectURL(this.blobURL);
    },
    onLoadData() {
      this.loading = true;
      this.loadData();
    },
    async loadData() {
      try {
        // load image
        let response;
        let splitURL = parseUrl(this.detailsObject.file);

        if (
          splitURL.protocol === "s3" ||
          splitURL.resource.endsWith(".amazonaws.com")
        ) {
          if (splitURL.pathname.startsWith("/")) {
            splitURL.pathname = decodeURI(splitURL.pathname.slice(1));
          }

          let s3Res = null;
          let s3Error = false;

          // S3 Amazon ask for credentials/request file loop
          // If user cancels credentials dialog exception will be thrown
          do {
            if (!this.s3CredentialsSet || s3Error) {
              await this.$refs.AmazonLogin.show();
            }

            try {
              // resource will be like: saliency-test.s3-us-west-2.amazonaws.com
              // first item - bucket
              let splitResource = splitURL.resource.split(".");

              s3Res = await new AWS.S3()
                .getObject({
                  Bucket: splitResource[0],
                  Key: splitURL.pathname
                })
                .promise();
            } catch (error) {
              apiError(error, this);
              s3Error = true;
            }
          } while (!s3Res);

          response = {
            data: new Blob([new Uint8Array(s3Res.Body)])
          };
          // name used in DICOMConverter
          response.data.name = splitURL.pathname;
        } else {
          response = await axios.get(this.detailsObject.file, {
            responseType: "blob"
          });
        }

	this.blobURL = window.URL.createObjectURL(response.data);

        if (isGraphicFile(this.detailsObject.file)) {
          this.imageURL = URL.createObjectURL(response.data);
        } else {
          // convert
          let dicoms = await DICOMConverter(response.data);
          this.imageURL = URL.createObjectURL(dicoms[0]);
        }

        this.loaded = true;
      } catch (error) {
        if (error !== "Cancelled") {
          apiError(error, this);
        }
      }

      this.loading = false;
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style lang="scss" scoped>
.load-button {
  width: 120px;
}

.square {
  &__image {
    width: 250px;
    margin-bottom: 10px;

    @media only screen and (min-width: 320px) and (max-width: 768px) {
      width: 150px;
    }
  }
}

.square-list {
  list-style: none;
  padding: 0px;

  &__item {
    display: flex;
  }

  &__key {
    width: 120px;

    @media only screen and (min-width: 320px) and (max-width: 768px) {
      width: 60px;
    }
  }

  &__value {

    @media only screen and (min-width: 320px) and (max-width: 768px) {
    }
  }
}

.anno-table {
  &__btn {
    border: none;
    color: white;
    background-color: #66615b;
    text-transform: uppercase;
    font-weight: bold;
    padding: 4px 8px;
    border-radius: 2px;
    margin: 5px;
    font-size: 0.8em;

    &:hover {
      background-color: #403d39;
    }

    &:disabled {
      background-color: #b4afa6;
    }
  }
}
</style>
